import { render } from "./FeatureItem.vue?vue&type=template&id=0b46009e&scoped=true&ts=true"
import script from "./FeatureItem.vue?vue&type=script&lang=ts"
export * from "./FeatureItem.vue?vue&type=script&lang=ts"

import "./FeatureItem.vue?vue&type=style&index=0&id=0b46009e&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b46009e"]])

export default __exports__